import Link from "next/link";
import styles from "../../styles/BreadCrumbs.module.css";
import {Categories }from "../list/PageList";



export default function BreadCrumbs(props) {

  function catcheck(value) {
    var myCom;
    //console.log(value);
    if (value!= null) {
      myCom =<li><Link href={props.catlink}><a>{props.cat}</a></Link></li>
      
    }

    return myCom;
  }

  return (
<div className={styles.container}>
<div className={styles.contant}>
<ol className={`${styles.breadcrumb }`}>
<li><Link href="/"><a>Playcutegames</a></Link></li>
<li><Link href="/c"><a>Categories</a></Link></li>
{catcheck(props.catlink)}
<li className={styles.current}><a>{props.gamename}</a></li>
</ol>
</div>
</div>
  );
}
